import { render, staticRenderFns } from "./ImportantEventsModalForm.vue?vue&type=template&id=5addbf88&"
import script from "./ImportantEventsModalForm.vue?vue&type=script&lang=js&"
export * from "./ImportantEventsModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports